"use strict";

const { getGlobalMonotonicClockMS } = require("./lib/global-monotonic-clock");
const { Performance } = require("./lib/performance");
const clockIsAccurate = require("./lib/clock-is-accurate");

module.exports = {
  Performance,
  getGlobalMonotonicClockMS,
  clockIsAccurate
};
